import { gsap, Power1 } from 'gsap';

class ContactBrevo {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => new Section(section));
	}
}
class Section {
	constructor(section) {
		this.section = section;
		this.radiosInputs = this.section.querySelectorAll('input[name="tabs"]');
		this.forms = this.section.querySelectorAll('.brevo__form');
		this.activeFormIndex = this.getActiveFormIndex();
		this.fields = [];
		this.forms.forEach((form) => {
			const fields = form.querySelectorAll('input, textarea');
			this.fields = [...this.fields, ...fields];
		});

		if (this.radiosInputs[this.activeFormIndex]) {
			this.radiosInputs[this.activeFormIndex].checked = true;
		}
		this.radiosInputs.forEach((input, index) => {
			input.addEventListener('click', () => {
				if (index === this.activeFormIndex) return;
				this.toggleForm(index);
			});
		});

		this.forms[this.activeFormIndex].style.display = 'block';
		this.forms[this.activeFormIndex].style.opacity = 1;

		this.forms.forEach((form) => {
			const submitButton = form.querySelector('.brevo__submit');

			function preventFormSubmission(event) {
				const isProcessing = form.querySelector('.sib_processing');
				if (isProcessing) {
					event.preventDefault();
					return;
				}
				this.addFocusListeners();
			}

			form.addEventListener('submit', (event) => {
				preventFormSubmission.call(this, event);
			});

			if (submitButton) {
				submitButton.addEventListener('click', (event) => {
					preventFormSubmission.call(this, event);
				});
			}
		});
	}

	toggleForm(index) {
		this.hideActiveForm(() => {
			this.activeFormIndex = index;
			this.showActiveForm();
		});
	}

	addFocusListeners() {
		this.fields.forEach((field) => {
			// Removes error class on focus
			field.addEventListener('focus', function (e) {
				this.classList.remove('error');
			});

			// Checks if the field is empty on blur
			field.addEventListener('blur', function (e) {
				if (this.value != '') this.classList.add('not-empty');
				else this.classList.remove('not-empty');
			});
		});
	}

	hideActiveForm(onComplete) {
		gsap.to(this.forms[this.activeFormIndex], {
			opacity: 0,
			display: 'none',
			duration: 0.2,
			ease: Power1.easeOut,
			onComplete,
		});
	}

	showActiveForm() {
		this.forms[this.activeFormIndex].style.display = 'block';
		this.forms[this.activeFormIndex].style.opacity = 0;
		gsap.to(this.forms[this.activeFormIndex], {
			opacity: 1,
			duration: 0.2,
			ease: Power1.easeIn,
		});
	}

	getActiveFormIndex() {
		const activeTab = new URLSearchParams(window.location.search).get('tabs');
		if (activeTab) {
			const tabIndex = Array.from(this.radiosInputs).findIndex((input) => input.value === activeTab);
			if (tabIndex > -1) return tabIndex;
		}

		return 0;
	}
}

export default ContactBrevo;
